import auth from "./auth";

export const useAuth = () => {
  const isAuthenticated = auth.isAuthenticated();
  const login = (credential, redirect) => {return auth.login(credential, redirect)}
  const logout = () => auth.logout();
  
  return { isAuthenticated, login, logout };
};
